import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'admin-lte/plugins/fontawesome-free/css/all.min.css';
import 'admin-lte/dist/css/adminlte.min.css';
import 'admin-lte/plugins/jquery/jquery.min.js';
import 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min.js';
import 'admin-lte/dist/js/adminlte.min.js';
import 'vue-multiselect/dist/vue-multiselect.css'
import 'chart.js'
import '../src/assets/style.css'

import axios from 'axios';
import {refreshAccessToken, verifyToken} from "@/services/tokenService";


const host_url = "https://adminpanel.salemsmart.kz/api/"
// const host_url = 'http://109.248.8.40:8001/api/';
// const host_url = 'http://localhost:8001/api/'
const axiosInstance = axios.create({
    baseURL: host_url,
})
axios.defaults.baseURL = host_url;

const app = createApp(App);

app.use(router);
app.use(store);

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = store.getters['tokens/access'];
        if (token && await verifyToken(token)) {
            config.headers['Authorization'] = `Bearer ${token}`; // Attach the access token to headers
        } else {
            await refreshAccessToken()
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response, // Pass successful responses
     async (error) => {
         const originalRequest = error.config;
         // Check for 401 error and if it's not already retried
         if (error.response && error.response.status === 401 && !originalRequest._retry) {
             originalRequest._retry = true; // Mark request as retried
             const refreshToken = store.getters['tokens/refresh'];

             // If no refresh token, redirect to log in
             if (!refreshToken && await verifyToken(refreshToken)) {
                 await store.dispatch('tokens/logout');
                 await router.push('/login');
             } else {
                 await router.push('login')
                 return Promise.reject(error)
             }

             // Attempt to refresh the token
             const newAccessToken = refreshAccessToken(refreshToken);
             if (newAccessToken) {
                 await store.dispatch('tokens/setAccess', newAccessToken);
                 originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`; // Update the original request header
                 return axiosInstance(originalRequest); // Retry the original request
             }
             // If refresh fails, log out and redirect to log in
             await store.dispatch('tokens/logout');
             await router.push('/login');
         }
         return Promise.reject(error); // Reject for other errors
     }
);

// export default axiosInstance;
app.mount('#app');